var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownIconWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.21967 8.71967C5.51256 8.42678 5.98744 8.42678 6.28033 8.71967L10 12.4393L13.7197 8.71967C14.0126 8.42678 14.4874 8.42678 14.7803 8.71967C15.0732 9.01256 15.0732 9.48744 14.7803 9.78033L10.5303 14.0303C10.3897 14.171 10.1989 14.25 10 14.25C9.80109 14.25 9.61032 14.171 9.46967 14.0303L5.21967 9.78033C4.92678 9.48744 4.92678 9.01256 5.21967 8.71967Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownIconWhite);
export default __webpack_public_path__ + "static/media/dropdown-icon-white.336dc6fb006253202c7b86d95635bdac.svg";
export { ForwardRef as ReactComponent };